<template>
  <div class="orders">
    <div class="operation-bar">
      <orders-recover></orders-recover>
      <orders-search></orders-search>
      <orders-operation :selected-ids="selectedIds"></orders-operation>
    </div>
    <pager v-bind:items="this.orders || []" :count="this.order_count"></pager>

    <div>
      <table class="table table-sm table-hover">
        <thead class="thead-default">
          <th v-on:click="toggleCheckAll()" nowrap>
            <input class="main-input-toggle" title="选择所有" type="checkbox" />
            <span v-if="selectedIds.length"> X{{ selectedIds.length }}</span>
          </th>
          <th nowrap>公司</th>
          <th>订单号</th>
          <th>产品类型/产品名</th>
          <th nowrap>状态</th>
          <th nowrap>份数</th>
          <th>时间</th>
          <th v-if="isAdmin || isPrinter">任务</th>
          <th>其他</th>
        </thead>
        <tbody>
          <tr
            v-for="order of this.orders"
            :class="getOrderStatusLevel(order)"
            :key="order.order_no"
            :id="order.order_no"
          >
            <b-popover
              :target="order.order_no"
              :title="order.consignee_name"
              triggers="hover click"
              placement="left"
            >
              <div>{{ order.consignee_phone }}</div>
              <div class="small">{{ order.consignee_address }}</div>
            </b-popover>
            <td>
              <input
                v-if="!order.deleted"
                class="sub-input-toggle"
                type="checkbox"
                :data-id="order.order_no"
                :data-display="order.company_order_no"
                :data-count="order.count"
                :data-size="JSON.stringify(calculateOrderSize(order))"
                :data-name="order.product_name"
                :checked="selectedIds.indexOf(String(order.order_no)) >= 0"
                @click="toggleCheck"
              />
            </td>
            <td :id="`popover-${order.order_no}`">
              {{ getCompanyDisplay(order.company_code) }}
            </td>
            <td>
              <router-link
                v-if="!order.deleted"
                :to="'/orders/' + order.order_no"
                >{{ order.order_no }}</router-link
              >
              <del v-else>{{ order.order_no }}</del>
              <br />

              <div v-if="!order.deleted">{{ order.company_order_no }}</div>
              <del v-else>{{ order.company_order_no }}</del>
            </td>
            <td>
              <router-link :to="'/orders?product_code=' + order.product_code">{{
                order.product_name
              }}</router-link>
              <div>{{ order.order_name }}</div>
              <div v-if="order.meta.inner_page_count">
                内页数：{{ order.meta.inner_page_count.join(", ") }}页
              </div>
            </td>
            <td>{{ getOrderStatusDisplay(order.status) }}</td>
            <td v-html="renderOrderItems(order)"></td>
            <td>
              <span v-if="order.created_at"
                >创建:<local-time :time="order.created_at"></local-time></span
              ><br />
              <span v-if="order.downloaded_at"
                >下载:<local-time
                  :time="order.downloaded_at"
                ></local-time></span
              ><br />
              <span v-if="order.sent_at"
                >发货:<local-time :time="order.sent_at"></local-time
              ></span>
            </td>
            <td v-if="isAdmin || isPrinter">
              <div v-for="task in order.meta.tasks">
                <span
                  ><router-link :to="'/tasks/' + task.id"
                    >{{ getTaskTypeDisplay(task.type) }}
                    {{ task.name || task.id }}</router-link
                  ></span
                >
              </div>
              <div v-for="task in order.meta.revoked_tasks">
                <span
                  ><router-link :to="'/tasks/' + task.id"
                    ><del
                      >{{ getTaskTypeDisplay(task.type) }}
                      {{ task.name || task.id }}</del
                    ></router-link
                  ></span
                >
              </div>
            </td>

            <td>
              <order-extra-item
                :order="order"
                :delivery="order.delivery"
                :show-ship-company="true"
              ></order-extra-item>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      class="alert alert-primary cart"
      role="alert"
      v-if="selectedIds.length"
    >
      <div>您选中了{{ selectedIds.length }}个订单</div>
      <div class="font-weight-bold">产品统计</div>
      <div v-for="(count, name) in productName">
        &nbsp;&nbsp;{{ name }}: {{ count }}个
      </div>
      <div class="font-weight-bold">文件尺寸统计</div>
      <div v-for="(size, type) in size">&nbsp;&nbsp;{{ type }}: {{ size }}</div>
      <div class="font-weight-bold">订单号如下</div>
      <div v-for="companyOrderNo in selectedDisplays">
        &nbsp;&nbsp;{{ companyOrderNo }}
      </div>
    </div>

    <div class="alert-box">
      <b-alert
        v-for="alert of alerts"
        :key="alert.key"
        show
        dismissible
        @dismissed="dismissAlert(alert)"
        variant="danger"
        >{{ alert.content }}</b-alert
      >
    </div>
  </div>
</template>

<script>
import Pager from "./_partial/Pager";
import OrdersSearch from "./_orders/OrdersSearch";
import OrdersOperation from "./_orders/OrdersOperation";
import LocalTime from "@/components/_small/LocalTime";
import InputMixin from "@/mixins/input";
import OrderMixin from "@/mixins/order";
import RoleMixin from "@/mixins/role";
import TaskMixin from "@/mixins/task";
import BasicMixin from "@/mixins/basic";
import LoadDataMixin from "@/mixins/load_data";
import OrderExtraItem from "@/components/_small/OrderExtra";
import OrdersRecover from "@/components/_orders/OrdersRecover";
import { showSuccessAlert } from "@/utils/alert";

function loadData() {
  this.$http.doSpin();
  return this.$http
    .get("/api/orders" + location.search)
    .then(response => {
      this.$http.cancelSpin();
      this.order_count = response.data.count;

      // 额外的操作，清除checkall的选中状态
      document.querySelector(".main-input-toggle").checked = false;
      this.orders = response.data.data;

      // 延迟加载alerts
      setTimeout(() => {
        this.loadAlerts();
      }, 100);
    })
    .catch(function(error) {
      console.log(error);
      this.$http.cancelSpin();
    });
}

function loadAlerts() {
  if (this.isAdmin || this.isPrinter() || this.isFinance) {
    this.$http.get("/api/alerts").then(response => {
      this.alerts = response.data.data;
    });
  }
}

function calculateOrderSize(order) {
  // order.files 包含多个文件，按照文件的product code对文件分类
  let data = {};
  for (let i = 0; i < order.order_files.length; i++) {
    let file = order.order_files[i];
    data[file.product_code] = (data[file.product_code] || 0) + file.size;
  }
  return data;
}

function dismissAlert(item) {
  this.$simpleHttp
    .put(`/api/alerts/${item.id}`, {
      read: true
    })
    .then(response => {
      showSuccessAlert("已暂时隐藏该问题");
    });
}

export default {
  name: "orders",
  mixins: [
    InputMixin,
    OrderMixin,
    TaskMixin,
    RoleMixin,
    BasicMixin,
    LoadDataMixin
  ],
  data() {
    return {
      items: [],
      order_count: -1,
      orders: [],
      alerts: []
    };
  },
  mounted() {
    this.loadData();
  },
  components: {
    Pager,
    LocalTime,
    OrdersSearch,
    OrdersOperation,
    OrderExtraItem,
    OrdersRecover
  },
  methods: {
    loadData,
    calculateOrderSize,
    loadAlerts,
    dismissAlert
  }
};
</script>

<style lang="scss" scoped>
table {
  font-size: 14px;
}
.cart {
  position: fixed;
  width: 350px;
  right: 20px;
  bottom: 20px;
  overflow-y: auto;
  max-height: 30%;
  z-index: 2000;
}

.alert-box {
  position: fixed;
  top: 55px;
  right: 20px;
  z-index: 2000;
}
</style>
